import React, { Fragment, Suspense,useState,useEffect, useMemo } from "react"
import { useSelector, useDispatch } from 'react-redux';
import PrivateLayout from './PrivateLayout/PrivateLayout';
import PublicLayout from './PublicLayout/PublicLayout';
import { Route, Redirect, Switch, withRouter } from "react-router-dom";
import privateRoutes from '../routes/private';
import adminRoutes from '../routes/admin';
import publicRoutes  from '../routes/public';
import _ from 'lodash';
import ErrorBoundary from './ErrorBoundary';
import Loader from '@iso/components/utility/loader';
import Page404 from "@iso/containers/Pages/404/404";
import VerifyPage from "@iso/containers/Pages/VerifyPage/VerifyPage";
import appActions from '@iso/redux/app/actions';
import { propertyService,subscriptionService } from '@iso/services';
import queryString from 'query-string';
import propertyActions from '@iso/redux/property/actions';
import { hiddenKeys, hasPlanAccess } from "./Sidebar/hiddenKeys";

const { changeCurrent } = appActions;
const { changeAgent } = propertyActions;

const Main = () => {
  const isLoggedIn = useSelector((state) => state.Auth.idToken);
  const currentUser = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const pathArray = window.location.pathname.split('/');
  const urlVerify = pathArray[1];
  const [stripePlan, setStripePlan] = useState();
  const activeId = useSelector((state) => state.property.activePropertyId);
  const activePropertySubscription = useSelector((state) => state.subscription.activePropertySubscription);
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const shareMapToken = queryString.parse(window.location.search).sharing_token || '';
  const formToken = queryString.parse(window.location.search).token || '';

  useEffect(() => {
    if (shareMapToken) {
      propertyService.getPropertyMetaByToken(shareMapToken).then(res => {
        if (res.code === '0000') {
          if (res.property_metas?.actived?.meta_value && res.property_metas?.is_for_sale?.meta_value) {
            dispatch(changeAgent(res.agent));
          } else {
            dispatch(changeAgent(null));
          }
        }
      });
    }
  }, [shareMapToken, dispatch]);

  const handlePrivateLayout = () => {

    if(isLoggedIn){
      // The SMS link a division contact opens is token-only, so it must also work
      // for anyone already signed in on that phone — system admins included.
      if(window.location.pathname === '/division-contact/confirm'){
        const DivisionContactConfirmComponent = publicRoutes.DivisionContactConfirm.component;
        return (
          <Route
            path="/division-contact/confirm"
            render={() => <PublicLayout component={DivisionContactConfirmComponent} />}
          />
        );
      }
      if(currentUser.is_system_admin == 1)
      {
        return (
          <PrivateLayout>
            <Switch>
              {_.map(adminRoutes, (route, key) => {
                const { component, path } = route;
                return (
                  <Route exact path={path} key={key} component={component}/>
                )
              })}
              <Route exact path="/" key="admin-dashboard" render={() => { dispatch(changeCurrent(['admin-dashboard'])); return ( <Redirect to="/admin-dashboard"/> ); }} />
              <Route component={Page404} />
            </Switch>
          </PrivateLayout>
        )
      }else{
        if(urlVerify === 'verify'){
          return (<Route path="/verify" component={VerifyPage} />);
        } else if(window.location.pathname === '/invitation-conflict'){
          // Render invitation conflict as standalone page outside private layout
          const InvitationConflictComponent = publicRoutes.InvitationConflict.component;
          return (
            <Route
              path="/invitation-conflict"
              render={() => <PublicLayout component={InvitationConflictComponent} />}
            />
          );
        } else if(urlVerify === 'sf-respond'){
          // SafeFarm SMS public response page — must render even when
          // the recipient happens to be logged in, and outside the app
          // chrome so it's the same minimal browser experience as for
          // anonymous corporate users (who can't open the mobile app).
          const SafefarmRespondComponent = publicRoutes.SafefarmRespond.component;
          return (
            <Route
              path="/sf-respond/:token"
              render={() => <PublicLayout component={SafefarmRespondComponent} />}
            />
          );
        } else {
          return (
            <PrivateLayout>
              <Switch>
                {_.map(privateRoutes, (route, key) => {
                  const { component, path } = route;
                  const pageKey = path.replace('/', '');
                  if(hiddenKeys().includes(pageKey) && !hasPlanAccess(pageKey, activePropertySubscription)){
                    return null;
                  }
                  if(!currentUser.is_public_view_user || path === '/share-map' || path === '/dashboard'){
                    return (
                      <Route exact path={path} key={key} component={component}/>
                    )
                  }
                })}
                {/* Allow logged-in users to access signup for invitation flow */}
                {_.map(publicRoutes, (route, key) => {
                  const { component, path } = route;
                  if(path === '/signup'){
                    return (
                      <Route exact path={path} key={key} component={component}/>
                    )
                  }
                })}
                <Route exact path="/" key="dashboard" render={() => { dispatch(changeCurrent(['dashboard'])); return ( <Redirect to="/dashboard"/> ); }} />
                <Route component={Page404} />
              </Switch>
            </PrivateLayout>
          )
        }
      }
      
    }
  }

  const exceptedRoutes = ["/visitor-form", "/contractor-form", "/stop-device-alarm-request", "/sar-elapsed-time","/thank-you","/l/:type/:id"]

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
          { handlePrivateLayout() }
          { !isLoggedIn && currentUser.is_system_admin != 1  &&
            <Fragment>
              <Switch>
                {_.map(privateRoutes, (route, key) => {
                  const { path } = route;
                  if(path === '/form-submission') {
                    return <Route exact path={path} key={key} render={() => ( <Redirect to={`/signin?form_token=${formToken}`} /> )} />
                  }else if(path === '/share-map') {
                    return <Route exact path={path} key={key} render={() => ( <Redirect to={`/signin?sharing_token=${shareMapToken}`} /> )} />
                  }else if(path === '/training-session/register/:id') {
                    // A QR scan can land here logged out. Carry the scanned URL
                    // through sign-in, otherwise the attendee logs in and finds
                    // themselves on the dashboard with no idea what to do next.
                    return <Route exact path={path} key={key} render={(route) => ( <Redirect to={`/signin?redirect=${encodeURIComponent(route.match.url)}`} /> )} />
                  }else if(!exceptedRoutes.includes(path)){
                    return (
                      <Route exact path={path} key={key} render={() => ( <Redirect to="/signup" /> )} />
                    )
                  }
                  
                })}
                {_.map(publicRoutes, (route, key) => {
                  const { component, path } = route;
                  return (
                    <Route
                      exact
                      path={path}
                      key={key}
                      render={route =>
                        { 
                          return (
                            <PublicLayout component={component} />
                          );
                        }
                      }
                    />
                  )
                })}
              <Route component={Page404} />
              </Switch>
            </Fragment>
          }
          { !isLoggedIn && currentUser.is_system_admin == 1 &&
            <Fragment>
              <Switch>
                {_.map(adminRoutes, (route, key) => {
                  const { path } = route;
                  return (
                    <Route exact path={path} key={key} render={() => ( <Redirect to="/signin"/> )} />
                  )
                })}
                {_.map(publicRoutes, (route, key) => {
                  const { component, path } = route;
                  return (
                    <Route
                      exact
                      path={path}
                      key={key}
                      render={route =>
                        { 
                          return (
                            <PublicLayout component={component} />
                          );
                        }
                      }
                    />
                  )
                })}
              <Route component={Page404} />
              </Switch>
            </Fragment>
          }
      </Suspense>
    </ErrorBoundary>
  );
}

export default withRouter(Main)
